// import http from "./http";

// /**
//  * FETCH ALL DATA - POST request
//  */
// export const getFolders = (schoolId) => http.post("all-data", { school_id: schoolId });

// /**
//  * DELETE ITEM - DELETE request with query params
//  * For file: type=file&student_id=xxx
//  * For folder: type=folder&class_id=xxx
//  * 
//  * IMPORTANT: Make sure to pass the correct ID:
//  * - For files: pass student_id
//  * - For folders: pass class_id (required!)
//  */
// export const deleteItem = async (type, id) => {
//   try {
//     const queryParams = { type };
    
//     // API requires different keys based on type
//     if (type === 'file') {
//       queryParams.student_id = id;  // student_id for file deletion
//     } else if (type === 'folder') {
//       queryParams.class_id = id;     // class_id for folder deletion (REQUIRED!)
//     }

//     console.log(`Deleting ${type} with params:`, queryParams); // Debug log

//     const response = await http.delete("all-data", { 
//       params: queryParams 
//     });
    
//     return response.data;
//   } catch (error) {
//     console.error("Delete error:", error);
//     if (error.response) {
//       return { 
//         status: false, 
//         message: error.response.data?.message || "Delete failed" 
//       };
//     }
//     return { status: false, message: error.message || "Network error" };
//   }
// };

import http from "./http";

/**
 * FETCH ALL DATA - POST request
 */
export const getFolders = (schoolId) => http.post("all-data", { school_id: schoolId });

/**
 * DELETE ITEM - DELETE request with query params
 * For file: type=file&student_id=xxx
 * For folder: type=folder&class_id=xxx
 */
export const deleteItem = async (type, id) => {
  try {
    const queryParams = { type };
    
    if (type === 'file') {
      queryParams.student_id = id;
    } else if (type === 'folder') {
      queryParams.class_id = id;
    }

    console.log(`Deleting ${type} with params:`, queryParams);

    const response = await http.delete("all-data", { 
      params: queryParams 
    });
    
    return response.data;
  } catch (error) {
    console.error("Delete error:", error);
    if (error.response) {
      return { 
        status: false, 
        message: error.response.data?.message || "Delete failed" 
      };
    }
    return { status: false, message: error.message || "Network error" };
  }
};